"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersection = useIntersection;
const react_1 = require("react");
const use_identity_ref_1 = require("../use-identity-ref");
const context_1 = require("../../context");
/**
 * Хук, вызывающий callback при пересечении целевого элемента с областью видимости.
 * @param ref Ref с целевым элементом.
 * @param callback Функция, которая будет вызвана при пересечении целевого элемента с областью видимости.
 * @param options Опции создания IntersectionObserver.
 */
function useIntersection(ref, callback, options) {
    const callbackRef = (0, use_identity_ref_1.useIdentityRef)(callback);
    const { createIntersectionObserver } = (0, react_1.useContext)(context_1.IntersectionObserverContext);
    (0, react_1.useEffect)(() => {
        const element = ref.current;
        if (element) {
            const observer = createIntersectionObserver(([entry]) => {
                callbackRef.current?.(entry);
            }, options);
            observer.observe(element);
            return () => observer.disconnect();
        }
    }, [ref, options, createIntersectionObserver]);
}
//# sourceMappingURL=index.js.map